module.exports = __webpack_public_path__ + "img/20200514_151934.a0ef3831.jpg";